import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function TicketsLayout({ children }: { children: React.ReactNode }) {
  const { t: tNav } = useTranslation("nav");

  return (
    <>
      <PageTitle>{tNav("tickets")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/tickets")({
  component: function LayoutRoute() {
    return (
      <TicketsLayout>
        <Outlet />
      </TicketsLayout>
    );
  },
});
